import React, { useState } from 'react'
import { DialogContent, DialogHeader, DialogTitle } from '@/Components/ui/dialog'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/Components/ui/form'
import { Input } from '@/Components/ui/input'
import { Button } from '@/Components/ui/button'

import { getAbbrWord } from '@/utils/helper'
import { toast } from 'react-toastify'
import Loader from '@/Components/Common/Loader'
import FollowupStatus from './Listing/FollowupStatus'
import FollowupStatusService from '@/Service/FollowupStatusService'

const CreateFollowupStatus = ({getfollowupStatus,setIsOpen}) => {
    const formSchema = z.object({
        followup_status: z
            .string({
                message: 'Followup Status is required.',
            })
            .min(1, {
                message: 'Followup Status is required.',
            }),
    })
    const [isSaving, setIsSaving] = useState(false)

    const form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            followup_status: '',
        },
    })

    async function onSubmit(values) {
        console.log('values', values)
        try {
            setIsSaving(true)
            const resp = await FollowupStatusService.createFollowupStatus(values)
            if (resp.data.success) {
                setIsSaving(false)
                const searchParams = new URLSearchParams(location.search)
                const page = searchParams.get('page')
                if (page) {
                    navigate('/setup/followup-status')
                } else {
                  getfollowupStatus()
                }
                form.reset({ followup_status: '' })
                setIsOpen(false)
            }
        } catch (err) {
            setIsSaving(false)
        }
    }

    function onError(errors, e) {
        const errorKeys = Object.keys(errors)
        if (errorKeys.length > 0 && errors[errorKeys[0]]?.message) {
            toast.error(errors[errorKeys[0]].message)
        }
        console.log(errors, e)
    }

    return (
        <DialogContent>
            <DialogHeader>
                <DialogTitle>Add Followup Status</DialogTitle>
            </DialogHeader>
            <div>
                <Form {...form}>
                    <form onSubmit={form.handleSubmit(onSubmit, onError)} className="space-y-4">
                        <FormField
                            control={form.control}
                            name="followup_status"
                            render={({ field }) => (
                                <FormItem className="space-y-1">
                                    <FormLabel required={true}>Followup Status</FormLabel>
                                    <FormControl>
                                        <Input
                                            {...field}
                                            className="shadow-none focus-visible:ring-transparent space-0 mt-0"
                                            placeholder="Followup Status"
                                            onChange={(e) => {
                                                field.onChange(e.target.value)
                                            }}
                                        />
                                    </FormControl>
                                </FormItem>
                            )}
                        />

                        <div className="flex justify-end">
                            <Button type="submit" className="bg-primary-purpal hover:bg-primary-purpal" disabled={isSaving}>
                                Submit {isSaving && <Loader fullScreen={false} />}
                            </Button>
                        </div>
                    </form>
                </Form>
            </div>
        </DialogContent>
    )
}

export default CreateFollowupStatus
